export default "__VITE_ASSET__5c2ca900__"